var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 106 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_110_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1439 0.036499C61.1443 0.036499 53.0941 8.80464 53.0941 19.696C53.0941 30.5874 61.1443 39.3555 71.1439 39.3555C81.1435 39.3555 89.1938 30.5874 89.1938 19.696C89.1938 8.80464 81.1435 0.036499 71.1439 0.036499ZM35.0443 19.696C25.0447 19.696 16.9945 28.4641 16.9945 39.3555C16.9945 50.2469 25.0447 59.015 35.0443 59.015C45.0439 59.015 53.0941 50.2469 53.0941 39.3555C53.0941 28.4641 45.0439 19.696 35.0443 19.696ZM71.1439 45.9087C67.2551 45.9087 63.5871 46.7878 60.2036 48.2765L62.9416 54.2665C65.5156 53.2147 68.2228 52.4618 71.1439 52.4618C80.0665 52.4618 87.74 57.7521 91.8965 65.5682H98.7005C94.0709 53.9876 83.5191 45.9087 71.1439 45.9087ZM35.0443 65.5682C18.3782 65.5682 4.9613 80.1816 4.9613 98.334V104.887H65.1273V98.334C65.1273 80.1816 51.7104 65.5682 35.0443 65.5682ZM35.0443 72.1213C48.3772 72.1213 59.1107 83.8121 59.1107 98.334H10.9779C10.9779 83.8121 21.7114 72.1213 35.0443 72.1213ZM83.1771 72.1213V85.2277H71.1439V91.7808H83.1771V104.887H89.1938V91.7808H101.227V85.2277H89.1938V72.1213H83.1771Z",
    fill: "#0096FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_110_914",
    x: 0.961304,
    y: 0.036499,
    width: 104.266,
    height: 112.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_914"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_110_914",
    result: "effect2_dropShadow_110_914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_110_914",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.c4deb2fbb60ea9aa8130fddca70ca3c1.svg";
export { ForwardRef as ReactComponent };